import getConfig from 'next/config'
const { publicRuntimeConfig } = getConfig()

// Environment checks
export const IS_DEVELOPMENT = process.env.NODE_ENV === 'development'
export const IS_PRODUCTION = process.env.NODE_ENV === 'production'
export const IS_TEST = process.env.NODE_ENV === 'test'

// Browser feature detection
export const IS_BROWSER = typeof window !== 'undefined'
export const IS_SERVER = !IS_BROWSER

// Modern browser features
export const SUPPORTS_WEBP =
  IS_BROWSER &&
  (() => {
    const canvas = document.createElement('canvas')
    canvas.width = 1
    canvas.height = 1
    return canvas.toDataURL('image/webp').startsWith('data:image/webp')
  })()

export const SUPPORTS_AVIF =
  IS_BROWSER &&
  (() => {
    const canvas = document.createElement('canvas')
    canvas.width = 1
    canvas.height = 1
    return canvas.toDataURL('image/avif').startsWith('data:image/avif')
  })()

export const PUBLIC_FONTS_VERSION = 'v1'
export const PUBLIC_IMAGES_VERSION = 'v1'
export const PUBLIC_VIDEOS_VERSION = 'v1'
export const PUBLIC_CSS_VERSION = 'v1'

// Env-specific variables
export const APP_ENV = (publicRuntimeConfig?.APP_ENV ?? process.env.APP_ENV) as
  | 'qa'
  | 'preprod'
  | 'prod'
export const CDN_URL = publicRuntimeConfig?.CDN_URL
// For asset urls that occur at both runtime and build time, this defaults to CDN_URL at runtime and CDN_URL_TEMPLATE which needs to be string replaced at build time
export const CDN_URL_TEMPLATE = publicRuntimeConfig?.CDN_URL ?? process.env.CDN_URL_TEMPLATE ?? ''
export const PUBLIC_STATIC_ASSET_PREFIX = process.env.PUBLIC_STATIC_ASSET_PREFIX ?? ''
export const SERVICE_NAME = process.env.SERVICE_NAME || 'super-funnel'
export const GNAR_CLIENT_ID = process.env.GNAR_CLIENT_ID || 'superhumanFunnel'

export const APP_VERSION = publicRuntimeConfig?.APP_VERSION

export const HOMEPAGE_HERO_IMAGE_COLUMNS = 6
